import React, { useEffect } from 'react';
import './AboutPage.css';

function AboutPage() {
  const founderData = {
    alan: {
      name: 'Alan Iannaccone, PE',
      role: 'Co-Founder & CEO',
      headshot: '/about_us_page/alan_iannaccone_headshot.jpg',
      bio: 'Alan is a licensed professional engineer and MBA candidate at Boston College who co-founded DocuHounds after experiencing firsthand how chaotic academic life can be. He leads product vision, strategy, and user experience, and is focused on building tools that remove friction from learning and help students thrive.'
    },
    austin: {
      name: 'Austin Long',
      role: 'Co-Founder & CTO',
      headshot: '/about_us_page/austin_long_headshot.jpg',
      bio: 'Austin is a software engineer with over 15 years of experience and is also an MBA candidate at Boston College. He leads engineering and technical development at DocuHounds, building the AI infrastructure that powers features like smart calendar syncing, campus automation, and contextual document chat.'
    }
  };

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    document.title = 'About Us – DocuHounds';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Meet the founders of DocuHounds, the AI-powered academic assistant built by students for students. Learn how we help you stay organized and thrive.';
  }, []);

  return (
    <div className="about-page">
      <div className="warroom-container">
        {/* About Section as a formal section header */}
        <section className="about-header">
          <h1 className="about-title">About DocuHounds</h1>
          <h2 className="about-tagline">Built to remove friction.
          Designed to give time back.</h2>

          <div className="about-body">
            <p>DocuHounds is an AI-powered academic operating system built by engineers and operators who were tired of chaos.</p>
            <p>We turn syllabi, documents, and deadlines into a single intelligent workflow. Automatically.</p>
            <p>Students don’t need more tools. They need a system.</p>
          </div>
        </section>

        <div className="short-divider" />

        {/* FOUNDERS — single synchronized grid (COMMAND zone) */}
        <section className="founders-section">
          <div className="founders-inner">
            <div className="founders-header">
              <h2 className="founders-title">The Founders</h2>
              <div className="founders-kicker">LEADERSHIP. ENGINEERING. EXECUTION.</div>
            </div>

            <div className="founders-grid">
            {/* Alan */}
            <div>
              <div className="founder-card">
                <div className="status-bar">
                  <span className="status-role">PRODUCT • STRATEGY • STANDARDS</span>
                </div>
                <div className="founder-main">
                  <img src={founderData.alan.headshot} alt={founderData.alan.name} className="founder-portrait" />
                  <div className="founder-copy">
                    <h3>{founderData.alan.name}</h3>
                    <div className="founder-role">{founderData.alan.role}</div>
                    <p className="founder-bio">{founderData.alan.bio}</p>
                  </div>
                </div>

                <div className="operational-background">
                  <h5>Operational Background</h5>
                  <ul>
                    <li>Licensed Professional Engineer (PE)</li>
                    <li>Utility & infrastructure engineering background</li>
                    <li>Led complex projects across regulated industries</li>
                  </ul>
                </div>

                <div className="education-list">
                  <div className="education-title">Education</div>
                  <div>MBA — Boston College</div>
                  <div>BS — Mechanical Engineering</div>
                </div>
              </div>
            </div>

            {/* Austin */}
            <div>
              <div className="founder-card">
                <div className="status-bar">
                  <span className="status-role">ARCHITECTURE • INFRASTRUCTURE • RELIABILITY</span>
                </div>
                <div className="founder-main">
                  <img src={founderData.austin.headshot} alt={founderData.austin.name} className="founder-portrait" />
                  <div className="founder-copy">
                    <h3>{founderData.austin.name}</h3>
                    <div className="founder-role">{founderData.austin.role}</div>
                    <p className="founder-bio">{founderData.austin.bio}</p>
                  </div>
                </div>

                <div className="operational-background">
                  <h5>Operational Background</h5>
                  <ul>
                    <li>15+ years production software engineering</li>
                    <li>Architected distributed systems and cloud platforms</li>
                    <li>Led microservices, infrastructure, and reliability efforts</li>
                  </ul>
                </div>

                <div className="education-list">
                  <div className="education-title">Education</div>
                  <div>MBA — Boston College</div>
                  <div>BS — Computer Science</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </section>

        {/* DOCTRINE — single horizontal strip */}
        <section className="doctrine-row">
          <div className="op-card">
            <h4>Design Philosophy</h4>
            <p>We build from lived experience. If it doesn’t save time, it doesn’t ship.</p>
          </div>
          <div className="op-card">
            <h4>Engineering Standard</h4>
            <p>Reliability is not a feature. It’s the baseline.</p>
          </div>
          <div className="op-card">
            <h4>Focus</h4>
            <p>Fewer tools. Less noise. More control.</p>
          </div>
        </section>

        {/* Mission — plain text, narrow */}
        <section className="mission">
          <div className="mission-body">
            <h3 className="mission-title">The Mission</h3>
            <p className="mission-text">We remove friction from academic life so students stay ahead of deadlines, stay organized, and focus on learning—not logistics.</p>
          </div>
        </section>

        {/* Certification band — centered, tighter */}
        <div className="certification-band centered">
          <div className="certification-inner">
            <div className="cert-label">DESIGN PHILOSOPHY</div>
            <div className="cert-title">Built by students. Engineered to hold up.</div>
            <ul className="cert-list">
              <li>— Student-first by design</li>
              <li>— Automation that saves real hours every week</li>
              <li>— Fewer tools. Less noise. More control.</li>
            </ul>
          </div>
        </div>


        {/* Final Statement - no container */}
        <section className="final-statement">
          <p className="final-strong">DocuHounds isn’t a feature set. It’s a system.</p>
          <p className="final-muted">We’re not chasing trends. We’re building infrastructure for how students actually work.</p>
        </section>
      </div>
    </div>
  );
}

export default AboutPage;